module.exports = __webpack_public_path__ + "img/2-full-lg.15149f03.jpg";